export const formatSubscriptionDate = value => {
  if (!value) return '—';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return '—';
  return new Intl.DateTimeFormat('en-CA', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
  }).format(parsed);
};

export const subscriptionStatusLabel = status => ({
  Active: 'Access active',
  FreePeriod: 'Free access active',
  ActivationRequired: 'Activate your free year',
  Pending: 'Access starts later',
  GracePeriod: 'Payment overdue — grace period',
  PastDue: 'Payment overdue',
  Restricted: 'Access paused — payment required',
  Suspended: 'Access paused',
  Expired: 'Access expired',
  Cancelled: 'Plan cancelled',
  Mixed: 'Different access statuses',
  NoDevices: 'No devices',
}[status] || status);

export const billingIntervalLabel = interval => interval === 'Annual' ? 'annual' : interval === 'Monthly' ? 'monthly' : interval?.toLowerCase();
